import { BodyText } from "@/components/ui/Text";
import { Radio } from "lucide-react";

export const LiveChatIndicator = () => {
  return (
    <div className="flex items-center gap-1 text-success">
      <Radio className="w-3 h-3" />
      <BodyText size="xs" textColor="success">
        Live message
      </BodyText>
    </div>
  );
};
